import { render, staticRenderFns } from "./reply-detail.vue?vue&type=template&id=6f1107e8&scoped=true"
import script from "./reply-detail.vue?vue&type=script&lang=js"
export * from "./reply-detail.vue?vue&type=script&lang=js"
import style0 from "./reply-detail.vue?vue&type=style&index=0&id=6f1107e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1107e8",
  null
  
)

export default component.exports